export enum httpResponseStatus {
  success,
  failure,
  aborted,
}
